import React, { Component } from 'react';

import Navbar from './Navbar';
import Sidebar from './Sidebar';

class MenuPrincipal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMenuOpen: false
        }
        this.onClickMenuIcon = this.onClickMenuIcon.bind(this);
        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize)
    }

    handleResize() {
        //Fechando o menu quando estiver numa resolução pequena (max-width: 993px)
        if (window.innerWidth < 993) {
            this.setState({ isMenuOpen: false });
        }
    }

    onClickMenuIcon() {
        this.setState({ isMenuOpen: !this.state.isMenuOpen });
    }

    render() {
        return (
            <div className={(!this.state.isMenuOpen ? "adap-sidebar-collapsed " : "")}>
                <Navbar
                    profile={this.props.profile}
                    photo={this.props.photo}
                    onClickMenuIcon={this.onClickMenuIcon}
                    onLogout={this.props.onLogout}
                />

                <Sidebar
                    menu={this.props.menu}
                    alertas={this.props.alertas}
                />

                <div className="adap-sidebar-fix edb-top-fix adap-main-container">
                    {this.props.body}
                </div>
            </div>
        );
    }
}

export default MenuPrincipal;